<!--
 * @Description:
 * @Author: 王佳兴
 * @Github:
 * @Date: 2019-01-15 19:30:59
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-05-06 22:18:33
 -->
<template>
  <div class="task">
    <div class="complain" @click="toComplain()">投诉</div>
    <div
      class="comWrapper"
      @touchmove.prevent
      v-show="comFlag"
      @click="comFlag = false"
    >
      <div class="comBox" @click.stop>
        <div class="imgBox">
          <img src="https://cdn.yxvzb.com/WEB/complain/voice.png" />
          <p>投诉成功</p>
        </div>
        <p class="disturb">
          若您觉得打扰，可到个人中心-个人设置中，自定义每日任务提醒频次。
        </p>
        <div class="gotta" @click="comFlag = false">知道了</div>
      </div>
    </div>
    <div class="TopBox">
      <div class="userImg">
        <img :src="taskData.headPhoto" />
        <p class="userName">{{ taskData.userName }}</p>
        <div class="toScore" @click="toShop()">积分商城</div>
      </div>
      <div class="integralBox">
        <div class="currentIntegral">
          <p>{{ taskData.userTotalScore }}</p>
          <p>总积分</p>
        </div>
        <div class="line"></div>
        <div class="getIntegral">
          <p>{{ taskData.userTodayScore < 0 ? 0 : taskData.userTodayScore }}</p>
          <p>今日已领取积分</p>
        </div>
      </div>
    </div>
    <ul class="list">
      <li
        v-for="(item, index) in tasks"
        :key="index"
        v-if="!isXCX || (isXCX && item.name != '分享精彩')"
        :class="[item.status == 1 ? 'readyLi' : '', 'lis-g']"
        @click="jumpPage(item)"
      >
        <div class="imgs">
          <img
            :src="
              item.status == 1
                ? `//cdn.yxvzb.com/img/myTask/${item.img2}`
                : `//cdn.yxvzb.com/img/myTask/${item.img}`
            "
            alt=""
          />
        </div>
        <div class="right">
          <div>
            <span class="list_name">{{ item.name }}</span>
            <span
              :class="[
                'list_integral',
                item.name == '暗语红包' ? 'list_integral_ay' : ''
              ]"
            >
              {{ item.intgral }}
            </span>
            <span
              id="list_to"
              :class="[item.status == 1 ? 'list_to_ready' : 'list_to_not']"
            >
              {{
                item.status == 1
                  ? '已完成'
                  : item.tit == 'activity'
                  ? '打卡'
                  : '前往'
              }}
            </span>
          </div>
          <p class="list_des">{{ item.des }}</p>
          <p v-if="item.name == '暗语红包'" class="aypaopao">
            {{
              argotStart ? '确认过眼神，红包给暗语对的人' : '本轮活动还未开始'
            }}
          </p>
        </div>
      </li>
      <div class="notes">
        *
        如需退订每日任务处理通知，可在菜单“个人中心”-“个人设置”-“任务提醒设置”中关闭/修改。
      </div>
    </ul>
  </div>
</template>
<script>
/*
 * 换图片
 * 打卡移植当前页面
 * 答题当前页面SC  直接进入
 *
 *
 * */
import { mapState } from 'vuex';
import { everyDayTask } from '@/api/ajax.js';
export default {
  name: '',
  data() {
    return {
      tasks: [],
      dk: false,
      comFlag: false,
      isXCX: false,
      argotStart: false,
      showPaopao: false,
      taskData: {}
    };
  },
  methods: {
    toComplain() {
      sa.track('complain', { type: 'click_complain' }, function() {
        location.href = '/html/complain.html#/home';
      });
    },
    toShop() {
      this.$router.push({ name: 'headlineDetail', params: { id: 16207 } });
    },
    jumpPage(item) {
      if (item.status != 1) {
        if (item.tit == 'activityStatus') {
          // let hours = new Date().getHours()
          // // if(hours > 3 && hours < 10){
          //  if(!this.dk){
          //      this.dk = true
          //      this.$http.post(`${this.api.pathUrl}/twentyOneSignOn/signUp`,{
          //          userOpenId:this.api.getStorage('wxUserInfo').wxOpenId
          //      }).then(res=>{
          //          if(res.data.status == 'succuss'){
          //              Toast('打卡成功~')
          //              item.status = 1
          //              sa.track('daily_task', {
          //                  'from':'wx',
          //                  'type':'Daily_clock'
          //              },function () {
          //
          //              });
          //          }
          //          this.dk = false
          //      })
          //  }
          this.$sa.setSaSession_href(this.$route, item.url);

          // }else{
          //     Toast('4点-10点之间才可以打卡~')
          // }

          //                        location.href = item.url + '?userOpenId=' + this.api.getStorage('wxUserInfo').wxOpenId
        } else {
          let _this = this;
          function scFunc(types) {
            sa.track(
              'daily_task',
              {
                from: 'wx',
                type: types
              },
              function() {
                _this.$sa.setSaSession_href(_this.$route, item.url);
              }
            );
          }
          if (item.tit == 'answer') {
            this.$sa.re_click({
              target_name: '答题拼图'
            });
            scFunc('Answer_questions');
          } else if (item.tit == 'liveSignUpStatus') {
            this.$sa.re_click({
              target_name: '直播报名'
            });
            scFunc('Live_sign_up');
          } else if (item.tit == 'videoSignInStatus') {
            this.$sa.re_click({
              target_name: '录播签到'
            });
            scFunc('Course_sign_in');
          } else if (item.tit == 'shareStatus') {
            this.$sa.re_click({
              target_name: '分享精彩'
            });
            scFunc('share');
          } else if (item.tit == 'perfectInfoStatus') {
            this.$sa.re_click({
              target_name: '完善信息'
            });
            scFunc('dailyTask_perfect');
          } else if (item.tit == 'argot') {
            this.$sa.re_click({
              target_name: '暗语红包'
            });
            if (this.argotStart) {
              scFunc('argot');
            } else {
              this.showPaopao = true;
              setTimeout(() => {
                this.showPaopao = false;
              }, 2500);
            }
          }
        }
      }
    },
    getInfo() {
      let parameter = {
        userId: this.wxUserInfo.id,
        wxOpenId: this.wxUserInfo.wxOpenId
      };

      everyDayTask().then(res => {
        this.taskData = res.data.data;
        this.assign(res.data.data);
        this.$http
          .post('/rest/ysh/wx/watchword/obtainTodayInformationData')
          .then(res => {
            let filterTime = time => {
              let hour =
                new Date(time).getHours() < 10
                  ? '0' + new Date(time).getHours()
                  : new Date(time).getHours();
              let min =
                new Date(time).getMinutes() < 10
                  ? '0' + new Date(time).getMinutes()
                  : new Date(time).getMinutes();
              return `${hour}:${min}`;
            };

            let { publishStatus, publishTime } = res.data;
            let nowDate = new Date().getTime();
            // 如果是暗语则动态修改时间
            this.tasks.forEach((item, index) => {
              if (item.name == '暗语红包') {
                this.tasks[index].intgral = publishTime
                  ? `活动时间 ${filterTime(publishTime)}-24:00`
                  : '';
              }
            });
            // 有暗语
            if (publishStatus === 1 && publishTime) {
              if (nowDate >= publishTime) {
                this.argotStart = true;
              } else {
                this.argotStart = false;
                let argotStartInter = setInterval(() => {
                  nowDate = new Date().getTime();
                  if (nowDate >= publishTime) {
                    clearInterval(argotStartInter);
                    this.argotStart = true;
                  }
                }, 1000);
              }
            } else {
              this.argotStart = false;
            }
          });
      });
    },
    assign(statusArg) {
      let data = [
        {
          img: 'rz.png',
          img2: 'rz.png',
          name: '每日打卡',
          intgral: '抽奖',
          status: statusArg.activityStatus,
          des: '连续21天打卡,100%中奖',
          tit: 'activityStatus',
          url: `/html/twentyOne.html?t=${new Date().getTime()}#/main`
        },
        {
          img: 'dj.png',
          img2: 'dj.png',
          name: '答题拼图',
          intgral: '100%现金奖励',
          status: 0, // statusArg.answerStatus 没有返回这个,
          des: '每日来答题,学知识领红包',
          tit: 'answer',
          url: '/html/answerGold/index210505.html'
        },
        // {
        //   img: "ayicon.png",
        //   img2: "ayicon.png",
        //   name: "暗语红包",
        //   intgral: "红包",
        //   status: 0,
        //   des: "阅读资讯获得暗语，千元红包等你来抢",
        //   tit: "argot",
        //   url: "/html/newWechat.html#/argotList"
        // },
        {
          img: 'rz.png',
          img2: 'rz.png',
          name: '完善信息',
          intgral: '+50积分',
          status: statusArg.perfectInfoStatus,
          des: '获取更精准的学习内容推荐',
          tit: 'perfectInfoStatus',
          url: '/html/perfect.html#/perfect'
        },
        {
          img: 'zb.png',
          img2: 'zb1.png',
          name: '直播报名',
          intgral: '红包',
          // status: statusArg.liveSignUpStatus,
          status: 0,
          des: '邀请好友报名直播,领红包奖励',
          tit: 'liveSignUpStatus',
          url: '/html/newWechat.html#/liveTrailer'
        },
        {
          img: 'qd.png',
          img2: 'qd1.png',
          name: '课程签到',
          intgral: '+20积分',
          status: statusArg.videoSignInStatus,
          des: '听课时间大于1分钟即可签到',
          tit: 'videoSignInStatus',
          url: '/html/newWechat.html#/courseList'
        }
        // {
        //   img: 'jc.png',
        //   img2: 'jc1.png',
        //   name: '分享精彩',
        //   intgral: '+15积分',
        //   status: statusArg.shareStatus,
        //   des: '分享课程、学院或阅读至微信，3积分/次',
        //   tit: 'shareStatus',
        //   url: '/html/newWechat.html#/headlineList'
        // }
      ];
      let arrLeft = [],
        arrRight = [];
      data.forEach((item, index) => {
        if (item.status == 0) {
          arrLeft.push(item);
        } else {
          arrRight.push(item);
        }
      });

      this.tasks = arrLeft.concat(arrRight);
    }
  },
  computed: {
    ...mapState({
      wxUserInfo: state => state.wxUserInfo
    })
  },
  components: {},
  mounted() {
    if (/isTemp=2/.test(location.href)) {
      //首管消息
      sa.track(
        'first_attention',
        {
          from: 'wx',
          type: 'daily_task'
        },
        function() {}
      );
    }
    sa.track(
      'daily_task',
      {
        from: 'wx',
        type: 'Open_daily_task'
      },
      function() {}
    );
  },
  created() {
    let initData = {
      perfectInfoStatus: 0,
      liveSignInStatus: 0,
      watchCourseStatus: 0,
      userTodayScore: 0,
      userTotalScore: '',
      authStatus: 0,
      activityStatus: 0,
      videoSignInStatus: 0,
      liveSignUpStatus: 0,
      userName: '',
      shareStatus: 0,
      headPhoto: ''
    };
    this.assign(initData);
    this.getInfo();
    if (localStorage.hasCom) {
      localStorage.removeItem('hasCom');
      this.comFlag = true;
    }

    if (window.__wxjs_environment === 'miniprogram') {
      this.isXCX = true;
    }
  }
};
</script>
<style lang="less" scoped>
.task {
  .TopBox {
    width: 100%;
    background: linear-gradient(0deg, rgba(0, 187, 246, 0.49) 5%, #025afa 95%);
    position: relative;
    padding: 0.9rem 0.733rem 0.8533rem 0.733rem;
  }
  .userImg {
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    -webkit-justify-content: flex-start;
    align-items: center;
    -webkit-align-items: center;
    margin-bottom: 0.546rem;
    position: relative;
  }
  .userImg img {
    width: 1.4133rem;
    height: 1.4133rem;
    border-radius: 50%;
  }
  .userName {
    color: #fff;
    font-size: 0.4rem;
    text-align: center;
    margin-left: 0.266rem;
  }
  .toScore {
    width: 2.4rem;
    height: 0.9067rem;
    /*opacity: 0.7;*/
    background: #027cfa;
    border-radius: 0.08rem;
    font-size: 0.4rem;
    color: #fff;
    text-align: center;
    line-height: 0.9067rem;
    position: absolute;
    right: 0;
  }
  .integralBox {
    display: -webkit-flex; /* 鏂扮増鏈娉�: Chrome 21+ */
    display: flex; /* 鏂扮増鏈娉�: Opera 12.1, Firefox 22+ */
    -webkit-justify-content: center;
    justify-content: center;
    align-items: center;
    -webkit-align-items: center;
  }

  .currentIntegral,
  .getIntegral {
    width: 50%;
    text-align: center;
    color: #fff;
    font-size: 0.32rem;
  }
  .currentIntegral p:nth-of-type(1),
  .getIntegral p:nth-of-type(1) {
    font-size: 0.5067rem;
    line-height: 1;
  }
  .line {
    width: 0.0267rem;
    background: #fff;
    height: 0.667rem;
  }

  .list {
    width: 95%;
    margin: auto;
    position: relative;
    top: -0.5rem;
  }
  .list li {
    width: 100%;
    height: 2.24rem;
    background: #ffffff;
    box-shadow: 0 0.08rem 0.306rem 0 rgba(153, 153, 153, 0.3);
    border-radius: 0.106rem;
    display: flex;
    align-items: center;
    padding: 0 0.35rem;
    font-size: 0.4rem;
    color: #161616;
    margin-bottom: 0.45rem;
  }
  .list span {
    display: inline-block;
  }
  .list_integral {
    color: #027cfa;
  }
  #list_to {
    width: 1.86rem;
    height: 0.8rem;

    border-radius: 0.08rem;

    text-align: center;
    line-height: 0.8rem;
    position: absolute;
    right: 0.5rem;
    color: #fff !important;
  }
  .list_to_not {
    background: #027cfa;
  }
  .list_to_ready {
    background: #d8d8d8;
  }
  .list_des {
    font-size: 0.32rem;
    color: #666;
    margin-top: 0.3rem;
  }
  .imgs {
    width: 1.133rem;
    height: 0.867rem;
    margin-right: 0.333rem;
  }
  .imgs img {
    max-width: 100%;
  }
  .right {
    width: 82%;
  }
  .readyLi * {
    color: #666 !important;
  }
  .lis-g {
    position: relative;
  }
  .aypaopao {
    height: 0.7rem;
    position: absolute;
    top: -0.4rem;
    right: 1.5rem;
    background: url(http://cdn.yxvzb.com/img/myTask/aypaopao2.png);
    background-size: 100% 100%;
    font-size: 0.24rem;
    color: #520c62;
    text-align: center;
    padding: 0 0.2rem;
    /* padding-top: .02rem; */
    line-height: 0.6rem;
  }
  .list_integral_ay {
    font-size: 0.2667rem /* 20/75 */;
    color: #fb4a3a !important;
  }

  .list_integral {
    color: #027cfa;
    width: 47%;
    text-align: right;
  }
  .notes {
    width: 9.2rem;
    margin: auto;
    font-size: 0.32rem;
    color: #999;
    margin-top: 0.4rem;
    line-height: 0.44rem;
  }
  .complain {
    font-size: 0.37rem;
    color: #ffffff;
    width: 1rem;
    height: 0.53rem;
    line-height: 0.53rem;
    position: absolute;
    top: 0.15rem;
    right: 0.27rem;
    z-index: 10;
  }
  .comWrapper {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 100;
  }
  .comBox {
    width: 7.87rem;
    height: 5.33rem;
    background: #fff;
    border-radius: 0.21rem;
    margin: auto;
    margin-top: 4.53rem;
    padding: 0.89rem 0.88rem 0 0.88rem;
  }
  .imgBox {
    display: flex;
    align-items: center;
  }
  .imgBox img {
    width: 0.91rem;
    height: 0.91rem;
    border-radius: 50%;
    margin-left: 1.33rem;
    margin-right: 0.44rem;
  }
  .imgBox > p:first-of-type {
    font-size: 0.56rem;
    color: #161616;
  }
  .disturb {
    text-align: center;
    font-size: 0.35rem;
    text-align: center;
    margin: 0.48rem 0 0.56rem 0;
    color: #575757;
  }
  .gotta {
    width: 6.4rem;
    height: 0.93rem;
    border: 1px solid #979797;
    border-radius: 1.33rem;
    line-height: 0.93rem;
    text-align: center;
    font-size: 0.43rem;
    color: #161616;
  }
}
</style>
